import React from "react";
import _ from "lodash";
import { isPRDataEmpty } from "../../../../utils/workout-stats";
import EmptyStatementMsg from "./EmptyStatementMsg";
import PRItem from "./PRItem";
import PRRow from "./PRRow";
import { PR_TYPES } from "../../../../constants";

const PersonalRecordsCard = ({
  PRData = {},
  units = "Kg",
  isCheckIn = false,
}) => {
  const PRDataEmpty = isPRDataEmpty(PRData);
  const prRows = {
    repMaxPR: getRepMaxPRRow,
    volumePR: getVolumePRRow,
    e1rmPR: getE1rmPRRow,
  };

  const rows = [];
  for (const prType of PR_TYPES) {
    if (!PRData[prType.name]) {
      continue;
    }
    if (_.isEmpty(PRData[prType.name])) {
      continue;
    }
    rows.push(prRows[prType.name](prType, PRData, units));
  }

  return (
    <article id="personal-records-card">
      {!isCheckIn && <p className="s1 mb-4">Personal records</p>}
      {PRDataEmpty ? (
        <EmptyStatementMsg message="No data to show" />
      ) : (
        <div className="pr-data">{rows}</div>
      )}
    </article>
  );
};

const getRepMaxPRRow = (prType, PRData, units) => {
  const prItems = [];
  for (let exerciseName in PRData[prType.name]) {
    for (let repRange in PRData[prType.name][exerciseName]) {
      const load = PRData[prType.name][exerciseName][repRange].load;
      const delta = PRData[prType.name][exerciseName][repRange].delta;
      prItems.push(
        <PRItem
          key={`${exerciseName}${load}${repRange}`}
          exerciseName={_.capitalize(exerciseName)}
          value={`${repRange}RM = ${load}`}
          units={units}
          delta={delta}
        />
      );
    }
  }
  return (
    <PRRow key={prType.title} title={prType.title}>
      {prItems}
    </PRRow>
  );
};

const getVolumePRRow = (prType, PRData, units) => {
  const prItems = [];
  for (let exerciseName in PRData[prType.name]) {
    const volume = PRData[prType.name][exerciseName].volume;
    const delta = PRData[prType.name][exerciseName].delta;
    prItems.push(
      <PRItem
        key={`${exerciseName}${volume}`}
        exerciseName={_.capitalize(exerciseName)}
        value={volume}
        units={units}
        delta={delta}
      />
    );
  }
  return (
    <PRRow key={prType.title} title={prType.title}>
      {prItems}
    </PRRow>
  );
};

const getE1rmPRRow = (prType, PRData, units) => {
  const prItems = [];
  for (let exerciseName in PRData[prType.name]) {
    const e1rm = PRData[prType.name][exerciseName].e1rm;
    const delta = PRData[prType.name][exerciseName].delta;
    prItems.push(
      <PRItem
        key={`${exerciseName}${e1rm}`}
        exerciseName={_.capitalize(exerciseName)}
        value={e1rm}
        units={units}
        delta={delta}
      />
    );
  }

  return (
    <PRRow key={prType.title} title={prType.title}>
      {prItems}
    </PRRow>
  );
};

export default PersonalRecordsCard;
